import { Avatar, Box } from "@mui/material";
import React from "react";

interface ChangeAvatarImageProps {
  /**
   * An image as a base64 encoded string.
   */
  image: string;
}

export default function ChangeAvatarImage(props: ChangeAvatarImageProps): React.JSX.Element { 
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center"
      }}>
      <Avatar src={props.image} sx={{width: 256, height: 256}} />
    </Box>
  );
}